import { Component, OnInit,Input,SimpleChanges,OnChanges,Output,EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SubscriptionService } from '../../../services/subscription.service';
import { ParameterService } from '../../../services/parameter.service';
import {ChangeDetectorRef} from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-renew-subscription',
  templateUrl: './renew-subscription.component.html',
  styleUrls: ['./renew-subscription.component.scss']
})
export class RenewSubscriptionComponent implements OnInit,OnChanges {


  @Input() userId: any;
  @Output() close = new EventEmitter();
  profileForm: FormGroup;
  loading:boolean=false;
  packageList:any[]=[];
  paymentMethodList:any[]=[];

  constructor(private ref: ChangeDetectorRef,private parameterService:ParameterService,private subscriptionService:SubscriptionService) { }

  ngOnInit(): void {
    this.getList();
    this.getpaymentmethod();
    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.userId);
  }

  

  getpaymentmethod(){
    this.parameterService.getPaymentMethod().subscribe(resp=>{
      this.paymentMethodList = resp.data;
      this.ref.detectChanges();

    })
  }

  getList(){
    this.parameterService.getPackageMasterList().subscribe(resp=>{
   
     if(resp.data){
      this.packageList = resp.data.filter((item) => item.trial === false);
      
     }
     this.ref.detectChanges();
     
    },error=> {this.ref.detectChanges();});
  }

  closeModal(){
    console.log("close")
    this.close.emit('');
  }

  initalizeForm() {
    this.profileForm = new FormGroup({
      packageId: new FormControl("", {
        updateOn: 'change',
        validators: [Validators.required]
      }), 
      paymentMethod: new FormControl("", {
        updateOn: 'change',
        validators: [Validators.required]
      })
    });

  
  }

  submit(){
    this.loading= true;
    let param ={
      userId: this.userId,
      packageId: parseInt(this.profileForm.value.packageId),
      paymentMethod:parseInt(this.profileForm.value.paymentMethod)
    }
    this.subscriptionService.renew(param).subscribe(resp=>{
      this.loading= false;
      if(resp.statusCode == 200 ){
        this.alert2(resp.statusMessage,"success");
      
      }else{
        this.alert2(resp.statusMessage,"error");
      
      }
      this.ref.detectChanges();
    },error=>{
      this.loading= false;
      this.alert2("Failed renew subscription","error");
      this.ref.detectChanges();
    })
  }

  alert2(msg, status) {
    Swal.fire({
      text: msg,
      icon: status,
      buttonsStyling: false,
      confirmButtonText: "Ok",
      customClass: {
        confirmButton: "btn font-weight-bold btn-primary"
      }
    }).then((result) => {
      if (result.value) {
        this.close.emit('close');
      }

    })
  }

}
